import { GroupService } from "@src/app/services/groupService/group-service.service";
import { ImageryProviderService } from "@src/app/services/imageryProvider/imagery-provider.service";
import { BehaviorSubject } from "rxjs";
import { appInjector } from "src/app/classes/appInjector";
import { CesiumAdapterService } from "src/app/services/cesiumAdapter21/cesium-adapter.service";
import {ConcreteLayerService} from '@src/app/services/concreteLayer/concrete-layer.service';
import {Group} from '@src/app/classes/Groups/Group';

const $ = window['jQuery'];

export class EnvironmentConfig {

  public componentConfigs = {};
  public viewportWidth = window.innerWidth;
  public viewportHeight = window.innerHeight;
  public bounds:any = false;
  public heading:any = false;
  public timeline:any = false;
  public zoomLevel:any = false;
  public hiddenGroups:any = false;
  public groupLabelsVisibility:{id:number, visibility:boolean}[] = null;
  public hiddenItems:any = false;
  public imageryMode:any = false;
  public greyscale:any = false;
  public labelsVisible:any = true;
  public timezoneOffsetInSeconds:number = 0;
  public timezoneName = null;
  public zoomLevelHeights = null;


  public selectedModeName = null;
  public selectedMode = null;

 public prevSelectedMode = {name: null, val: null};

 public prevSelectedModeName = this.prevSelectedMode.name;
 public prevSelectedModeVal = this.prevSelectedMode.val;
  //public boundsSetupSubject = new BehaviorSubject<any>(0);
	//public boundsready = this.boundsSetupSubject.asObservable();



  constructor() {
    this.timezoneOffsetInSeconds = -(new Date()).getTimezoneOffset() * 60;
    this.timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let cesiumAdapterService:CesiumAdapterService = appInjector.get(CesiumAdapterService);
    let groupService:GroupService = appInjector.get(GroupService);
    let imageryProviderService:ImageryProviderService = appInjector.get(ImageryProviderService);
    let csAdapter:ConcreteLayerService = appInjector.get(ConcreteLayerService);
    cesiumAdapterService.adapterInitialized.subscribe(async (isLoaded)=>{
      if (isLoaded && (!this.bounds || !this.heading)){
        this.viewportWidth = $('.cesium-viewer').width();
        this.viewportHeight = $('.cesium-viewer').height();
        //this.bounds = await cesiumAdapterService.getViewRectangleAsync();
        this.heading = cesiumAdapterService.getViewHeading();
        this.greyscale = cesiumAdapterService.isBwActive;
        this.hiddenGroups = groupService.getHiddenGroups;
        this.groupLabelsVisibility = groupService.getLabelsVisibility();
        let groups = groupService.groupList;
        let hiddenItems = [];
        groups.forEach((g:Group)=>{
          if (!g.is_empty && g.items.length > 0){
            g.items.forEach((_i)=>{
              if (!_i.isVisible()){
                hiddenItems.push(_i.getId());
              }
            })
          }
        })
        this.hiddenItems = hiddenItems;
        this.zoomLevel = cesiumAdapterService.getCurrentZoom();




        this.prevSelectedMode = imageryProviderService.prevSelectedMode;

        this.prevSelectedModeVal = imageryProviderService.prevSelectedMode.val;
        this.prevSelectedModeName = imageryProviderService.prevSelectedMode.name;

        this.selectedModeName = imageryProviderService.selectedModeName;
        this.selectedMode = imageryProviderService.selectedMode;
      }
    });

    this.zoomLevelHeights = cesiumAdapterService.getCurrentZoomLevelHeights();
  }

  public assign(config) {
    if (config instanceof EnvironmentConfig) {
      this.componentConfigs = config.componentConfigs;
    }
  }

  public addComponentConfig(name, config) {
    this.componentConfigs[name] = config;
  }

  public getComponentConfig(name) {
    return this.componentConfigs[name];
  }

  public hasComponentConfig(name) {
    if(typeof this.componentConfigs !== 'undefined'){
      return this.componentConfigs.hasOwnProperty(name);
    }else{
      return false;
    }
  }
}


